module.exports = __webpack_public_path__ + "static/img/logo-inverted.2b046879.svg";